import { useState, useEffect } from "react";
import { useConfig } from "../contexts/config";
import { useAuth } from "../contexts/AuthContext";
import { setActivityProgressCompletedManually } from "../services/moodle/courses";
import { use } from "react";
import { useMoodleV2 } from "../contexts/moodle";
import { useNavigate, useParams } from "react-router-dom";

const useActivityCompleted = (resource) => {
  const { config } = useConfig();
  const moodlev2 = useMoodleV2();
  const params = useParams();
  const navigate = useNavigate();
  const [resourceIsTracked, setResourceIsTracked] = useState(false);
  const [resourceIsCompleted, setResourceIsCompleted] = useState(false);
  const [disabledCompleteAcivity, setDisabledCompleteAcivity] = useState(false);
  const [activityCompletedButtonClicked, setActivityCompletedButtonClicked] =
    useState(false);

  const auth = useAuth();
  const { user } = auth;
  
  const handleCompletedActivity = async () => {
    console.log(config);
    if (config.opciones && config.opciones.includes("completadomanual")) {
      setDisabledCompleteAcivity(true);
      if (resourceIsTracked && resourceIsCompleted) {
        setResourceIsCompleted(false);
        let response = await setActivityProgressCompletedManually({
          token: user.token,
          cmid: resource.id,
          completed: 0,
        });
        console.log(
          "response setActivityProgressCompletedManually No completado",
          response
        );
        if (response.status !== true) {
          setResourceIsCompleted(true);
        }
      } else if (resourceIsTracked && !resourceIsCompleted) {
        setResourceIsCompleted(true);
        let response = await setActivityProgressCompletedManually({
          token: user.token,
          cmid: resource.id,
          completed: 1,
        });
        if (response.status !== true) {
          setResourceIsCompleted(false);
        }
        console.log(
          "response setActivityProgressCompletedManually Completado",
          response
        );
      }
      setDisabledCompleteAcivity(false);
      setActivityCompletedButtonClicked((prev) => !prev);
      moodlev2
        .getCourseContentByID(params.id, true, window.location.search)
        .catch((err) => {
          console.log(err);
        });
    }
  };




  return {
    resourceIsTracked,
    resourceIsCompleted,
    disabledCompleteAcivity,
    setResourceIsTracked,
    setResourceIsCompleted,
    setDisabledCompleteAcivity,
    handleCompletedActivity,
    activityCompletedButtonClicked,
  };
};

export default useActivityCompleted;
